import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { new_session_path } from '@routes';
import { ClickTarget, click } from '@tracking';

import Button from '../../Button';

const SignInOption = ({ ...rest }) => {
  const { trackEvent } = useEventTracking();

  return (
    <div {...rest}>
      <span className="opacity-50">Already a subscriber? </span>
      <Button
        className="mt-8 font-suisse-screen text-disclosure-sm text-overline-sm text-grayscale-beige underline underline-offset-4 opacity-50 transition-colors hover:border-primary-magenta hover:text-primary-magenta hover:opacity-100 focus:border-primary-magenta focus:text-primary-magenta"
        as="link"
        href={new_session_path()}
        onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.SignIn }))}
      >
        Sign in
      </Button>
    </div>
  );
};

export default SignInOption;
